import React from "react";
import SectionShell from "./SectionShell";

export default function NewPerspectiveSection() {
  return (
    <SectionShell
      id="nezopont"
      testId="new-perspective-section"
      eyebrow="Egy apró elmozdulás"
      titleStart="Néha elég"
      titleAccent="más szemszögből"
      titleEnd=" ránézni"
    >
      {/* Symbolic image — sunset perspective, mountain vista, contemplation */}
      <figure className="my-8 md:my-10">
        <div className="portrait-frame relative max-w-xl mx-auto">
          <img
            data-testid="new-perspective-image"
            src="https://customer-assets.emergentagent.com/job_tiszta-tukor/artifacts/pl5op2lf_m%C3%A1s%20szemsz%C3%B6g.png"
            alt="Egy nyitott pergola naplementekor — más szemszögből látni a hegyek panorámáját"
            className="w-full h-auto object-cover block"
            style={{
              aspectRatio: "1 / 1",
              filter: "saturate(0.96) contrast(1.02)",
            }}
            loading="lazy"
          />
        </div>
      </figure>

      <p>
        Mindannyian hordozunk történeteket magunkról, másokról és a világról. Történeteket
        arról, hogy mire vagyunk képesek, mit érdemlünk, milyen egy jó kapcsolat, mit jelent
        szeretni és szerethetőnek lenni. A legtöbbször észre sem vesszük, hogy ezek csak
        egyetlen nézőpontból mutatják meg a világot és teljesen beszűkítik az általunk
        érzékelt valóságot. Miközben próbáljuk megoldani ugyanazokat a helyzeteket újra és
        újra, ugyanabból a szemszögből nézünk rájuk és kizárjuk az új lehetőségeket. Néha
        azonban elég egy apró elmozdulás, egy új nézőpont, egy felismerés. Majd hirtelen olyan
        lehetőségek válnak láthatóvá, amelyek addig ott voltak előttünk, mégsem vettük észre
        őket. Nem azért, mert nem léteztek. Hanem mert onnan még nem néztünk rájuk.
      </p>
    </SectionShell>
  );
}
